// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"568":"b3443f5d","985":"9a92defd"}[chunkId] + ".chunk.js";
};